
<p-card>
    <p-table [value]="snps" [tableStyle]="{'min-width': '50rem'}" #dt1
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['wellplateName','orderID','sampleName','strainName']">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton type="button" label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt1)"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')" placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr> 
                <th pSortableColumn="wellplateName" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Wellplate
                        <p-sortIcon field="wellplateName"></p-sortIcon>
                        <p-columnFilter type="text" field="wellplateName" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="orderId" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Order ID
                        <p-sortIcon field="orderId"></p-sortIcon>
                        <p-columnFilter type="text" field="orderId" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="orderDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Order Date
                        <p-sortIcon field="orderDate"></p-sortIcon>
                        <p-columnFilter type="date" field="orderDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="sampleName" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Sample
                        <p-sortIcon field="sampleName"></p-sortIcon>
                        <p-columnFilter type="text" field="sampleName" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="strainName" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Strain
                        <p-sortIcon field="strainName"></p-sortIcon>
                        <p-columnFilter type="text" field="strainName" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="referenceName" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Reference
                        <p-sortIcon field="referenceName"></p-sortIcon>
                        <p-columnFilter type="text" field="referenceName" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="concordance" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Concordance
                        <p-sortIcon field="concordance"></p-sortIcon>
                        <p-columnFilter type="numeric" field="concordance" display="menu"></p-columnFilter>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-snp>
            <tr (click)="rowClick(snp)">
                <td>{{snp.wellplateName}}</td>
                <td>{{snp.orderId}}</td>
                <td>{{snp.orderDate | date:'shortDate'}}</td>
                <td>{{snp.sampleName}}</td>
                <td>{{snp.strainName}}</td>
                <td>{{snp.referenceName}}</td>
                <td>{{snp.concordance | number: '1.0-2'}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>